import { GameScene } from '@Core/GameScene/GameScene';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { ESpecialGamesType } from '@GFTypes/SpecialGames';
import EventsCenter from '@Managers/Events/EventsCenter';
import { ALL_EVENTS_LIST } from '@Managers/Events/GameEvents';
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { SPECIAL_GAME_CONFIGS_GAMESTORE_KEYS, SPECIAL_GAME_PREFIX_PER_TYPE } from '../../Types/GameStoreTypes/SpecialGames';

export class SpecialGamesSpinCounter {
    private spinsPlayed: number = 0;
    private spinsTotal: number = 0;

    constructor(
        public readonly scene: GameScene,
        private readonly specialGamesType: ESpecialGamesType
    ) {
        Logger.log(LoggerLevel.Constructor, {
            class: SpecialGamesSpinCounter.name,
            source: LoggerSource.Game,
            message: 'SpecialGamesSpinCounter constructor'
        });
        EventsCenter.on(ALL_EVENTS_LIST.SPECIAL_GAMES_PLAYED_COUNTER_CHANGE, this.change, this);
        EventsCenter.on(ALL_EVENTS_LIST.SPECIAL_GAMES_TOTAL_COUNTER_CHANGE, this.syncTotal, this);

        this.syncTextVariables();
    }

    private syncTextVariables(): void {
        const { spinsTotal, spinsPlayed } = this;
        this.scene.game.gameStore.set(
            EGameStoreKeys.TextVariables,
            {
                [`${SPECIAL_GAME_PREFIX_PER_TYPE.get(this.specialGamesType)}SpinsTotal`]: String(spinsTotal),
                [`${SPECIAL_GAME_PREFIX_PER_TYPE.get(this.specialGamesType)}SpinsPlayed`]: String(spinsPlayed)
            },
            true
        );
    }

    public syncTotal(): void {
        this.sync(false, true);
    }

    public syncCurrent(): void {
        this.sync(true, false);
    }

    public sync(syncPlayed: boolean, syncTotal: boolean): void {
        const specialGamesConfigGameStoreKey = SPECIAL_GAME_CONFIGS_GAMESTORE_KEYS.get(this.specialGamesType)!;
        const config = this.scene.game.gameStore.get(specialGamesConfigGameStoreKey);
        const { currentSpin, totalSpins } = config;
        if (syncPlayed) this.spinsPlayed = currentSpin;
        if (syncTotal) this.spinsTotal = totalSpins;
        this.syncTextVariables();
    }

    public change(): void {
        this.spinsPlayed++;
        if (this.specialGamesType === ESpecialGamesType.LOCK_AND_ROLL) this.spinsTotal--;
        this.syncTextVariables();
    }

    public getSpinsPlayed(): number {
        return this.spinsPlayed;
    }

    public getSpinsTotal(): number {
        return this.spinsTotal;
    }
}
